import React from "react";
import { getColorForName } from "../../utils/utilityFunctions/stringUtility";
import AvatarName from "../UniversalComponents/AvatarName";

const ViewDelegation = ({ isFormDisabled, isEditTask, taskassignedtoref, handleMouseEnter, formData, depth }) => {
  return (
    <div
      className=" flex"
      style={{ opacity: isFormDisabled && isEditTask ? 0.5 : 1 }}
      onClick={(event) => {
        if (!(isFormDisabled && isEditTask)) {
          taskassignedtoref.current = event.target;
          handleMouseEnter(depth);
        }
      }}
    >
      {formData?.assigned_to
        ?.filter((assigned, index) => index < 3)
        ?.map((eachInput, index) => {
          const initials = eachInput?.name
            ?.split(" ")
            .filter((word) => word.length > 0)
            .map((word) => word.charAt(0).toUpperCase())
            .slice(0, 2)
            .join("");

          return (
            <div key={index} className="relative ml-[-5px]">
              <div
                style={{ backgroundColor: eachInput?.c_key }}
                className=" text-white text-12 font-600  flex items-center justify-center rounded-full"
              >
                <AvatarName
                  name={initials}
                  size="medium"
                  bgColor={getColorForName(initials || "#D8EEF7")}
                  textColor={"#ffffff"}
                  borderColor={"#ffffff"}
                />
              </div>
              {/* <button
                                          className="absolute top-[-4px] right-[-4px] bg-blue-500 text-white rounded-full w-[10px] h-[10px] flex items-center justify-center text-xs cursor-pointer"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            if (!isFormDisabled) {
                                              handleSelectPerson(e, eachInput);
                                            }
                                          }}
                                        >
                                          &times;
                                        </button> */}
            </div>
          );
        })}
      {formData?.assigned_to?.length > 3 && (
        <div className="ml-[-5px] z-100">
          <div className="bg-D8EEF7 text-gray-500 text-10 font-600 border border-white   w-7 h-7 flex items-center justify-center rounded-full">
            + {formData?.assigned_to?.length - 3}
          </div>
          {/* <button className="absolute top-[-4px] right-[-4px] bg-blue-500 text-white rounded-full w-[10px] h-[10px] flex items-center justify-center text-xs cursor-pointer">
                                      &times;
                                    </button> */}
        </div>
      )}
    </div>
  );
};

export default ViewDelegation;
